import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/auth'
import { watchlistService, type WatchlistSummary } from '@/services/watchlist-service'

interface UseUserWatchlistsResult {
  watchlists: WatchlistSummary[]
  isLoading: boolean
  error: string | null
  refetch: () => void
}

export function useUserWatchlists(): UseUserWatchlistsResult {
  const { isAuthenticated, isLoading: authLoading } = useAuth()
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['user-watchlists'],
    queryFn: () => watchlistService.getUserWatchlists(),
    enabled: isAuthenticated && !authLoading,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })

  return {
    watchlists: data?.watchlists || [],
    isLoading,
    error: error ? (error as any).message || 'Failed to load watchlists' : null,
    refetch,
  }
}